import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BaseEntity } from 'yt-ng-framework';

export class ResenjeZaPlacenoOdsustvoView extends BaseEntity {
  constructor() {
      super();
  }
  Osoba: number = null;
  Osnov: number = null;
  PodvrstaDokumentaStavka: string = null;
  BrojDokumenta: string = null;
  Datum: NgbDate = null;
  OdDatuma: Date = null;
  DoDatuma: Date = null;
  Dana: number = null;
  DatumPocetkaRada: Date = null;
  DatumZahteva: Date = null;
  Napomena: string = null;

  Deserialize(input: any) {
    this.ID = input.ID;
    this.Osoba = input.Osoba;
    this.Osnov = input.Osnov;
    this.PodvrstaDokumentaStavka = input.PodvrstaDokumentaStavka
    this.BrojDokumenta = input.BrojDokumenta;
    this.Datum = input.Datum;
    this.OdDatuma = input.OdDatuma;
    this.DoDatuma = input.DoDatuma;
    this.Dana = input.Dana;
    this.DatumPocetkaRada = input.DatumPocetkaRada;
    this.DatumZahteva = input.DatumZahteva;
    this.Napomena = input.Napomena;
    return this;
  }

  Serialize(input: ResenjeZaPlacenoOdsustvoView) {
      return input;
  }
}
